import { render } from "./Content.vue?vue&type=template&id=c21486cc"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import exportComponent from "/Users/YuyiiChiMila/Company/GAME-MAKRO/outlier-p002/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__